import { FC } from "react";
import Stack from "@mui/material/Stack";
import { useAppSelector } from "@/store/hooks";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";
import { DimensionCostAllocationCard } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/DimensionCostAllocationCard";

export const DimensionCostAllocationsList: FC = () => {
  const sharedCosts = useAppSelector(dimensionSharedCostsSelector);

  return (
    <Stack spacing={3}>
      {sharedCosts.map((sharedCost) => {
        return (
          <DimensionCostAllocationCard
            key={sharedCost.id}
            sharedCost={sharedCost}
          />
        );
      })}
    </Stack>
  );
};
